module.exports = __webpack_public_path__ + "components/rewards/intersport/static/logo-2899fe096a5a61c5a5d9f4a9443e9928.webp";